<template>
    <div
        :id="id"
        class="modal fade pe-0"
        tabindex="-1"
        role="dialog"
        :aria-labelledby="ariaLabelledby"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-slideout" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="btn-close ob1-link no-decoration"
                        data-bs-dismiss="modal"
                        aria-label="Fermer"
                        @click="clickHandler"
                    >
                        <span class="icon icon-delete" aria-hidden="true" />
                    </button>
                </div>
                <div class="modal-body">
                    <slot />
                </div>
                <div class="modal-footer">
                    <div class="row mx-0">
                        <div class="col-12 px-0">
                            <button
                                v-if="withCloseButton"
                                v-msh-html="buttonLabel"
                                type="button"
                                class="btn btn-primary"
                                data-bs-dismiss="modal"
                                @click="clickHandler"
                            />
                        </div>
                        <div class="col-12 px-0">
                            <lien
                                v-if="deleteSelectionLabel"
                                :is-button="true"
                                :label="deleteSelectionLabel"
                                :disabled="disabled || numberOfSelectedFilters === 0"
                                class="mt-1 noDefaultStyleButton"
                                @click="deleteSelectionClick"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import Lien from "../../../../common/components/ob1/Lien.vue";

export default {
    components: {Lien},
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        // id de la modal
        id: {
            type: String,
            required: true
        },
        // id du label qui va être utilisé pour la vocalisation (doit être présent dans le slot)
        ariaLabelledby: {
            type: String,
            required: true
        },
        deleteSelectionLabel: {
            type: String,
            default: undefined
        },
        numberOfSelectedFilters: {
            type: Number,
            default: 0
        },
        buttonLabel: {
            type: String,
            default: "Fermer"
        },
        withCloseButton: {
            type: Boolean,
            default: true,
        }
    },
    methods: {
        clickHandler: function () {
            this.$emit('slide-popin-modal-click');
        },
        deleteSelectionClick: function () {
            if (this.disabled) return;
            this.$emit('delete-selection-click');
        }
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.modal-open .modal {
    z-index: 10000;
}

.slide-popin-modal {
    .modal-dialog .modal-header .btn-close {
        &:before {
            display: none;
        }
        display: block;
    }

    .modal-dialog {

        max-width: 24%;
        height: auto;
        
        @media (min-width: #{map-get($grid-breakpoints, xs)}) and (max-width: #{map-get($grid-breakpoints, md)}) {
            max-width: 90%;
        }
        @media (min-width: #{map-get($grid-breakpoints, md)}) and (max-width: #{map-get($grid-breakpoints, lg)}) {
            max-width: 40%;
        }
        @media (min-width: #{map-get($grid-breakpoints, lg)}) and (max-width: #{map-get($grid-breakpoints, xl)}) {
            max-width: 32%;
        }

        @media (min-width: #{map-get($grid-breakpoints, xl)}) and (max-width: #{map-get($grid-breakpoints, xxl)}) {
            max-width: 28%;
        }

    }

    .modal-dialog .modal-content {
        padding-bottom: px-to-rem(0);
        @media (min-width: #{map-get($grid-breakpoints, xs)}) and (max-width: #{map-get($grid-breakpoints, md)}) {
            padding-top: 1.5625rem;
        }
        @media (min-width: #{map-get($grid-breakpoints, md)}) {
            padding-left: px-to-rem(15);
            padding-right: px-to-rem(15);
            padding-bottom: px-to-rem(20);
        }
        @media (min-width: #{map-get($grid-breakpoints, lg)}) {
            padding-bottom: px-to-rem(0);
        }
    }

    .modal-dialog-slideout {
        min-height: 100%;
        margin: 0 0 0 auto;
        background: #fff;
    }

    .modal.fade .modal-dialog.modal-dialog-slideout {
        -webkit-transform: translate(100%, 0) scale(1);
        transform: translate(100%, 0) scale(1);
    }

    .modal.fade.show .modal-dialog.modal-dialog-slideout {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
        display: flex;
        align-items: stretch;
        -webkit-box-align: stretch;
    }

    .modal.fade.show .modal-dialog.modal-dialog-slideout .modal-body {
        overflow: visible;
    }

    .modal-dialog-slideout .modal-content {
        border: 0;
        overflow: visible;
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }

    .modal-dialog-slideout .modal-body {
        flex: 1;
    }

    .modal-dialog-slideout .modal-header {
        position: sticky;
        top: 0;
        padding-top: px-to-rem(30);
        padding-bottom: px-to-rem(40);
        height: 30px;
        right: 2.3125rem;
        background: #fff;
        z-index: 10;
    }
    .modal-dialog-slideout .modal-footer {
        position: sticky;
        bottom: 0;
        padding-top: px-to-rem(20);
        padding-bottom: px-to-rem(120);
        height: 30px;
        background: #fff;
        z-index: 10;
        margin-top: auto;
    }
}

</style>
